__turbopack_context__.v({
  "criteriaBundle": "mY1KoW_criteriaBundle",
  "criteriaContainer": "mY1KoW_criteriaContainer",
  "criteriaTitle": "mY1KoW_criteriaTitle",
  "criterias": "mY1KoW_criterias",
  "tags": "mY1KoW_tags",
  "textSizeFix": "mY1KoW_textSizeFix",
  "threeLineEllipse": "mY1KoW_threeLineEllipse",
});
